module.exports = fox._r("fonts/PTSans-Bold.woff", __webpack_public_path__ + "_/_/_/root/fonts/1n84fCs.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/PTSans-Bold.woff
// module id = 197
// module chunks = 4